module.exports = __webpack_public_path__ + "img/ffp-bg.00f2a3e6.png";